export class StringUtil {

    public static getNumberFromStr(str: string | undefined | null, defaultValue: number = 0): number {
        if (!str || this.isNullOrWhiteSpace(str)) {
            return defaultValue;
        }
        const number = Number.parseFloat(str.replace(",", "."));
        return isNaN(number) ? defaultValue : number;
    }

    public static capitalize(str: string): string {
        if (!str) return str;
        return `${str[0].toUpperCase()}${str.substr(1)}`;
    }

    public static isNullOrWhiteSpace(str: string | undefined | null): boolean {
        if (typeof str === "undefined" || !str) {
            return true;
        }
        return str.replace(/\s/g, "").length < 1;
    }

    public static isEmptyOrWhiteSpace(str: string): boolean {
        return str.trim().length === 0;
    }

    public static convertToBoolean(value: string | undefined): boolean {
        return value === "true";
    }

    public static getColorFromString(str: string): string | null {
        let color: string | null = null;

        if (str.indexOf("#") !== -1) {
            color = "#";
            for (let index = str.indexOf("#") + 1; !this.isNullOrWhiteSpace(str[index]); index++) {
                color += str[index];
            }
        } else if (str.indexOf("rgb") !== -1) {
            color = "rgb";
            for (let index = str.indexOf("rgb") + 3; str[index] !== ")"; index++) {
                color += str[index];
            }
            color += ")";
        }
        return color;
    }

}
